import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNavbarAppIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.001 1.1875C12.0223 1.20824 13.8209 2.95683 16.6348 5.76562C18.1248 7.25716 21.4814 10.9589 21.4814 14.6387C21.4813 17.0914 19.4908 19.0801 17.0391 19.0801C15.4289 19.08 14.0214 18.2219 13.2461 16.9395L13.2451 16.9404C13.1667 16.8447 13.0362 16.7666 12.8955 16.7666C12.6675 16.7668 12.4582 16.9275 12.4834 17.127C12.6534 18.4503 13.3981 21.711 16.334 22.8125H7.66504C10.6013 21.711 11.3465 18.4503 11.5176 17.127C11.5413 16.9274 11.333 16.7666 11.1045 16.7666C10.961 16.7668 10.8333 16.8449 10.7549 16.9404V16.9395C9.97626 18.222 8.57032 19.0801 6.95996 19.0801C4.50688 19.0801 2.51777 17.0914 2.51758 14.6387C2.51758 10.9589 5.87385 7.25716 7.36719 5.76562C10.193 2.93978 12.001 1.1875 12.001 1.1875ZM10.7979 9.48047H6.89648L10.0518 11.7725L8.84668 15.4795L12.001 13.1875L15.1543 15.4795L13.9482 11.7725L17.1025 9.48047H13.2031L12.001 5.77344L10.7979 9.48047Z",
		fill: "white"
	})
});
export default SvgNavbarAppIcon;
